import { Button, FormControl, FormHelperText, Input, Typography } from '@mui/material'
import { useFormikContext } from 'formik'

import { useStyles } from './styles'
import { HelperWrapper } from '../helper-wrapper'

interface IDeleteConfirmFormContentProps {
  disabled?: boolean
  title?: string
  submitText?: string
}

const DeleteConfirmFormContent = ({
  disabled,
  title,
  submitText,
}: IDeleteConfirmFormContentProps) => {
  const { values, errors, handleChange } = useFormikContext<{ delete: string }>()
  const classes = useStyles()

  return (
    <div className={classes.sectionWrapper}>
      <FormControl>
        <Typography className={classes.text}>
          {title || <HelperWrapper t="delete-confirm-title" />}
        </Typography>
        <Input
          autoComplete="off"
          disabled={disabled}
          fullWidth
          value={values.delete}
          name="delete"
          id="delete"
          onChange={handleChange}
          type="text"
        />
        <FormHelperText>
          <Typography className={classes.warningText}>
            {errors.delete && <HelperWrapper t={errors.delete} />}&nbsp;
          </Typography>
        </FormHelperText>
      </FormControl>
      <Button
        fullWidth
        variant="contained"
        className={classes.confirmButton}
        disabled={disabled}
        type="submit"
      >
        {submitText || <HelperWrapper t="delete-confirm-submit-button" />}
      </Button>
    </div>
  )
}

export { DeleteConfirmFormContent }
